import React from "react";
import { Modal } from "antd";
import LinkedinIcon from "../../assets/icons/LinkedinIcon";
import MailIcon from "../../assets/icons/MailIcon";
function ProfileImg({ image }) {
  return (
    <div
      className="about_profile_item_image"
      style={{
        background: `url(${image}) no-repeat center center`,
        backgroundSize: "cover"
      }}
    />
  );
}

class ProfileItem extends React.Component {
  constructor() {
    super();
    this.state = {
      visible: false
    };
  }
  showModal = () => {
    this.setState({
      visible: true
    });
  };

  handleCancel = e => {
    this.setState({
      visible: false
    });
  };
  render() {
    return [
      <div className="about_profile_item">
        <div role="presentation" onClick={this.showModal}>
          <ProfileImg image={this.props.profileImage} />
        </div>
        <div
          style={{
            fontSize: "18px",
            color: "#1abc9c",
            paddingTop: "10px",
            marginBottom: "-6px"
          }}
          role="presentation"
          onClick={this.showModal}
        >
          {this.props.name}
        </div>
        <div
          style={{
            fontSize: "16px",
            color: "#8c8c8c"
          }}
          role="presentation"
          onClick={this.showModal}
        >
          {this.props.position}
        </div>
        {this.props.linkedin && (
          <div style={{ textAlign: "center" }}>
            <a href={`mailto:${this.props.email}`}>
              <MailIcon />
            </a>{" "}
            <span style={{ padding: "1px 5px" }} />
            <a href={this.props.linkedin}>
              <LinkedinIcon />
            </a>
          </div>
        )}

        <p
          className="about_profile_item_description"
          id="desciptionID"
          role="presentation"
          onClick={this.showModal}
        >
          {this.props.description[this.props.language]
            .slice(0, 90)
            .trim()
            .concat("...")}
        </p>
      </div>,
      <Modal
        wrapClassName="vertical-center-modal"
        visible={this.state.visible}
        onCancel={this.handleCancel}
        footer={null}
      >
        <div style={{ marginTop: "-130px" }}>
          <ProfileImg image={this.props.profileImage} />
        </div>
        <div
          style={{
            fontSize: "18px",
            color: "#1abc9c",
            paddingTop: "10px",
            marginBottom: "-6px",
            textAlign: "center"
          }}
        >
          {this.props.name}
        </div>
        <div
          style={{
            fontSize: "16px",
            color: "#8c8c8c",
            textAlign: "center"
          }}
        >
          {this.props.position}
        </div>
        {this.props.linkedin && (
          <div style={{ textAlign: "center" }}>
            <a href={`mailto:${this.props.email}`}>
              <MailIcon />
            </a>{" "}
            <span style={{ padding: "1px 5px" }} />
            <a href={this.props.linkedin}>
              <LinkedinIcon />
            </a>
          </div>
        )}
        <p
          style={{
            whiteSpace: "normal",
            position: "relative",
            padding: "20px",

            textAlign: "justify"
          }}
        >
          {this.props.fullDescription[this.props.language]}
        </p>
      </Modal>
    ];
  }
}

export default ProfileItem;



// WEBPACK FOOTER //
// ./src/pages/About/ProfileItem.js